import React, { useState, useEffect } from 'react';
import '../css/Historia.css';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';

const HistoriaClinica = () => {
  const { idPaciente } = useParams();
  const navigate = useNavigate();

  const [heredoData, setHeredoData] = useState([]);
  const [noPatologicosData, setNoPatologicosData] = useState([]);
  const [selectedPatologias, setSelectedPatologias] = useState([]);
  const [patologicosData, setPatologicosData] = useState({});
  const BLOQUEO_KEY = `historia_bloqueado_${idPaciente}`;
  const [bloqueado, setBloqueado] = useState(false);
  const [registroExistente, setRegistroExistente] = useState(false);

  const patologicosItems = ["Otro"];

  useEffect(() => {
    const bloqueoGuardado = localStorage.getItem(BLOQUEO_KEY);
    if (bloqueoGuardado === 'true') setBloqueado(true);
    if (!idPaciente) return;

    fetch(`https://api.weareinfinite.mx/form/historia_clinicaV/${idPaciente}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al obtener historia clínica');
        return res.json();
      })
      .then(data => {
        let historia = {};

        if (Array.isArray(data) && data.length > 0 && data[0]) {
          historia = data[0];
          setRegistroExistente(true);
        } else {
          setRegistroExistente(false);
        }

        // HEREDO FAMILIARES
        setHeredoData(
          historia.heredo_familiares?.length
            ? historia.heredo_familiares
            : [
                {
                  no: false,
                  si: false,
                  familiar: '',
                  enfermedad: '',
                  fecha_inicio: '',
                  fallecido_si: false,
                  fallecido_no: false,
                },
              ]
        );

        // NO PATOLÓGICOS
        setNoPatologicosData(
          historia.no_patologicos?.length
            ? historia.no_patologicos
            : [
                {
                  no: false,
                  si: false,
                  sustancia: '',
                  fecha_inicio: '',
                  continua: false,
                  fecha_fin: '',
                  copas_semana: '',
                },
              ]
        );

        // PATOLÓGICOS
        const patologicos = Array.isArray(historia.patologicos)
          ? historia.patologicos
          : [];

        if (patologicos.length === 0) {
          setSelectedPatologias(patologicosItems);
          const detallesVacios = {};
          patologicosItems.forEach(p => {
            detallesVacios[p] = {
              fecha_inicio: '',
              continuaSi: false,
              continuaNo: false,
              resueltoFecha: '',
              manejoFarmacologico: '',
            };
          });
          setPatologicosData(detallesVacios);
        } else {
          setSelectedPatologias(patologicos.map(p => p.patologia));
          const detalles = {};
          patologicos.forEach(p => {
            detalles[p.patologia] =
              p.detalles || {
                fecha_inicio: '',
                continuaSi: false,
                continuaNo: false,
                resueltoFecha: '',
                manejoFarmacologico: '',
              };
          });
          setPatologicosData(detalles);
        }
      })
      .catch(() => {
        setRegistroExistente(false);
        setHeredoData([
          {
            no: false,
            si: false,
            familiar: '',
            enfermedad: '',
            fecha_inicio: '',
            fallecido_si: false,
            fallecido_no: false,
          },
        ]);
        setNoPatologicosData([
          {
            no: false,
            si: false,
            sustancia: '',
            fecha_inicio: '',
            continua: false,
            fecha_fin: '',
            copas_semana: '',
          },
        ]);
        const detallesVacios = {};
        patologicosItems.forEach(p => {
          detallesVacios[p] = {
            fecha_inicio: '',
            continuaSi: false,
            continuaNo: false,
            resueltoFecha: '',
            manejoFarmacologico: '',
          };
        });
        setSelectedPatologias(patologicosItems);
        setPatologicosData(detallesVacios);
      });
  }, [idPaciente]);

  // 🔹 HEREDO FAMILIARES
  const handleHeredoChange = (index, field, value) => {
    const newData = [...heredoData];
    newData[index] = { ...newData[index], [field]: value };
    if (field === 'no' && value) newData[index].si = false;
    if (field === 'si' && value) newData[index].no = false;
    setHeredoData(newData);
  };

  const addHeredoRow = () => {
    setHeredoData([
      ...heredoData,
      {
        no: false,
        si: false,
        familiar: '',
        enfermedad: '',
        fecha_inicio: '',
        fallecido_si: false,
        fallecido_no: false,
      },
    ]);
  };

  const removeHeredoRow = index => {
    const updated = heredoData.filter((_, i) => i !== index);
    setHeredoData(updated);
  };

  // 🔹 NO PATOLÓGICOS
  const handleNoPatologicosChange = (index, field, value) => {
    const newData = [...noPatologicosData];
    newData[index] = { ...newData[index], [field]: value };
    if (field === 'no' && value) newData[index].si = false;
    if (field === 'si' && value) newData[index].no = false;
    setNoPatologicosData(newData);
  };

  const addNoPatologicoRow = () => {
    setNoPatologicosData([
      ...noPatologicosData,
      {
        no: false,
        si: false,
        sustancia: '',
        fecha_inicio: '',
        continua: false,
        fecha_fin: '',
        copas_semana: '',
      },
    ]);
  };

  const removeNoPatologicoRow = index => {
    const updated = noPatologicosData.filter((_, i) => i !== index);
    setNoPatologicosData(updated);
  };

  // 🔹 PATOLÓGICOS
  const handleDetallePatologiaChange = (patologia, field, value) => {
    setPatologicosData(prev => ({
      ...prev,
      [patologia]: { ...prev[patologia], [field]: value },
    }));
  };

  // 🔹 GUARDAR
  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      idPaciente,
      heredo_familiares: heredoData,
      no_patologicos: noPatologicosData,
      patologicos: selectedPatologias.map(p => ({
        patologia: p,
        detalles: patologicosData[p] || {},
      })),
    };
    try {
      const response = await fetch(
        `https://api.weareinfinite.mx/form/historia_clinica/${idPaciente}`,
        {
          method: registroExistente ? 'PUT' : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error('Error al guardar');
      Swal.fire({
        icon: 'success',
        title: registroExistente
          ? 'Datos actualizados correctamente'
          : 'Datos guardados exitosamente',
      }).then(() => navigate(`/cronograma/${idPaciente}`));
      setRegistroExistente(true);
    } catch {
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar',
      });
    }
  };

  // 🔹 BLOQUEO
  const bloquearCampos = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Una vez bloqueado, solo podrá desbloquearse con contraseña.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, bloquear',
    }).then(result => {
      if (result.isConfirmed) {
        localStorage.setItem(BLOQUEO_KEY, 'true');
        setBloqueado(true);
      }
    });
  };

  const desbloquearCampos = () => {
    Swal.fire({
      title: 'Desbloquear formulario',
      input: 'password',
      inputLabel: 'Introduce la contraseña',
      showCancelButton: true,
      confirmButtonText: 'Desbloquear',
    }).then(result => {
      if (result.isConfirmed) {
        if (result.value === 'infinite') {
          localStorage.removeItem(BLOQUEO_KEY);
          setBloqueado(false);
        } else {
          Swal.fire({ icon: 'error', title: 'Contraseña incorrecta' });
        }
      }
    });
  };

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.15)',
        borderRadius: '16px',
        backdropFilter: 'blur(10px)',
        padding: '40px',
        width: '100%',
        maxWidth: '1200px',
      }}
    >
      {/* 🔹 HEREDO FAMILIARES */}
      <h3>Antecedentes Heredo Familiares</h3>
      <table border="1" style={{ width: '100%', marginBottom: 20 }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Sí</th>
            <th>Parentesco</th>
            <th>Enfermedad</th>
            <th>Fecha Inicio</th>
            <th>Fallecido Sí</th>
            <th>Fallecido No</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          {heredoData.map((fila, i) => (
            <tr key={i}>
              <td>
                <input
                  type="checkbox"
                  checked={fila.no}
                  onChange={e =>
                    handleHeredoChange(i, 'no', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={fila.si}
                  onChange={e =>
                    handleHeredoChange(i, 'si', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={fila.familiar}
                  onChange={e =>
                    handleHeredoChange(i, 'familiar', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={fila.enfermedad}
                  onChange={e =>
                    handleHeredoChange(i, 'enfermedad', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="date"
                  value={fila.fecha_inicio}
                  onChange={e =>
                    handleHeredoChange(i, 'fecha_inicio', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={fila.fallecido_si}
                  onChange={e =>
                    handleHeredoChange(i, 'fallecido_si', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={fila.fallecido_no}
                  onChange={e =>
                    handleHeredoChange(i, 'fallecido_no', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <button
                  onClick={() => removeHeredoRow(i)}
                  disabled={bloqueado}
                >
                  ❌
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={addHeredoRow} disabled={bloqueado}>
         Agregar fila
      </button>
<p>
   <br />
  <br />
  <br />
  
</p>
      {/* 🔹 NO PATOLÓGICOS */}
      <h3 style={{ marginTop: 30 }}>Antecedentes Personales No Patológicos</h3>
      <table border="1" style={{ width: '100%', marginBottom: 20 }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Sí</th>
            <th>Sustancia</th>
            <th>Fecha Inicio</th>
            <th>Continúa</th>
            <th>Fecha Fin</th>
            <th>Consumo/Semana</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          {noPatologicosData.map((fila, i) => (
            <tr key={i}>
              <td>
                <input
                  type="checkbox"
                  checked={fila.no}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'no', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={fila.si}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'si', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={fila.sustancia}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'sustancia', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="date"
                  value={fila.fecha_inicio}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'fecha_inicio', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={fila.continua}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'continua', e.target.checked)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <input
                  type="date"
                  value={fila.fecha_fin}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'fecha_fin', e.target.value)
                  }
                  disabled={bloqueado || fila.continua}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={fila.copas_semana}
                  onChange={e =>
                    handleNoPatologicosChange(i, 'copas_semana', e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <button
                  onClick={() => removeNoPatologicoRow(i)}
                  disabled={bloqueado}
                >
                  ❌
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={addNoPatologicoRow} disabled={bloqueado}>
         Agregar fila
      </button>

<p>
   <br />
  <br />
  <br />
  
</p>

<h3>Antecedentes Personales Patológicos</h3>
{selectedPatologias.map((patologia, index) => {
  const detalles = patologicosData[patologia] || {};

  // Aseguramos que nombreAlternativo sea array
  if (!Array.isArray(detalles.nombreAlternativo)) {
    detalles.nombreAlternativo = [""];
  }

  const isOtro = patologia === "Otro";

  return (
    <div key={index} style={{ marginBottom: 20 }}>
      {!isOtro ? (
        <h5>Detalles de: {patologia}</h5>
      ) : (
        <h5>Enfermedades</h5>
      )}

      {!isOtro ? (
        // Tabla para patologías normales
        <table border="1" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Fecha Inicio</th>
              <th>Continua</th>
              <th>Fecha Resuelto</th>
              <th>Manejo Farmacológico</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  type="date"
                  value={detalles.fecha_inicio || ""}
                  onChange={e =>
                    handleDetallePatologiaChange(patologia, "fecha_inicio", e.target.value)
                  }
                  disabled={bloqueado}
                />
              </td>
              <td>
                <label>
                  <input
                    type="checkbox"
                    checked={detalles.continuaSi || false}
                    onChange={e => {
                      handleDetallePatologiaChange(patologia, "continuaSi", e.target.checked);
                      handleDetallePatologiaChange(patologia, "continuaNo", !e.target.checked);
                    }}
                    disabled={bloqueado}
                  />{" "}
                  Sí
                </label>
                <label style={{ marginLeft: 10 }}>
                  <input
                    type="checkbox"
                    checked={detalles.continuaNo || false}
                    onChange={e => {
                      handleDetallePatologiaChange(patologia, "continuaNo", e.target.checked);
                      handleDetallePatologiaChange(patologia, "continuaSi", !e.target.checked);
                    }}
                    disabled={bloqueado}
                  />{" "}
                  No
                </label>
              </td>
              <td>
                <input
                  type="date"
                  value={detalles.resueltoFecha || ""}
                  onChange={e =>
                    handleDetallePatologiaChange(patologia, "resueltoFecha", e.target.value)
                  }
                  disabled={bloqueado || detalles.continuaSi === true}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={detalles.manejoFarmacologico || ""}
                  onChange={e =>
                    handleDetallePatologiaChange(patologia, "manejoFarmacologico", e.target.value)
                  }
                  placeholder="Medicamento"
                  disabled={bloqueado}
                />
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        // Tabla para "Otro"
        <div>
          {detalles.nombreAlternativo.map((nombre, i) => (
            <div key={i} style={{ marginBottom: 20 }}>
              <h5>
                Enfermedad {i + 1}: {nombre ? nombre : "(Sin nombre)"}
              </h5>

              <div style={{ marginBottom: 10 }}>
                <label>Nombre de la Enfermedad:</label>
                <input
                  type="text"
                  value={nombre}
                  onChange={e => {
                    const nuevos = [...detalles.nombreAlternativo];
                    nuevos[i] = e.target.value;
                    handleDetallePatologiaChange(patologia, "nombreAlternativo", nuevos);
                  }}
                  placeholder="Ej. Hipotiroidismo"
                  disabled={bloqueado}
                />
              </div>

              <table border="1" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Fecha Inicio</th>
                    <th>Continua</th>
                    <th>Fecha Resuelto</th>
                    <th>Manejo Farmacológico</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="date"
                        value={detalles[`fecha_inicio_${i}`] || ""}
                        onChange={e =>
                          handleDetallePatologiaChange(
                            patologia,
                            `fecha_inicio_${i}`,
                            e.target.value
                          )
                        }
                        disabled={bloqueado}
                      />
                    </td>
                    <td>
                      <label>
                        <input
                          type="checkbox"
                          checked={detalles[`continuaSi_${i}`] || false}
                          onChange={e => {
                            handleDetallePatologiaChange(
                              patologia,
                              `continuaSi_${i}`,
                              e.target.checked
                            );
                            handleDetallePatologiaChange(
                              patologia,
                              `continuaNo_${i}`,
                              !e.target.checked
                            );
                          }}
                          disabled={bloqueado}
                        />{" "}
                        Sí
                      </label>
                      <label style={{ marginLeft: 10 }}>
                        <input
                          type="checkbox"
                          checked={detalles[`continuaNo_${i}`] || false}
                          onChange={e => {
                            handleDetallePatologiaChange(
                              patologia,
                              `continuaNo_${i}`,
                              e.target.checked
                            );
                            handleDetallePatologiaChange(
                              patologia,
                              `continuaSi_${i}`,
                              !e.target.checked
                            );
                          }}
                          disabled={bloqueado}
                        />{" "}
                        No
                      </label>
                    </td>
                    <td>
                      <input
                        type="date"
                        value={detalles[`resueltoFecha_${i}`] || ""}
                        onChange={e =>
                          handleDetallePatologiaChange(
                            patologia,
                            `resueltoFecha_${i}`,
                            e.target.value
                          )
                        }
                        disabled={bloqueado || detalles[`continuaSi_${i}`] === true}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={detalles[`manejoFarmacologico_${i}`] || ""}
                        onChange={e =>
                          handleDetallePatologiaChange(
                            patologia,
                            `manejoFarmacologico_${i}`,
                            e.target.value
                          )
                        }
                        placeholder="Medicamento"
                        disabled={bloqueado}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}

          <button
            type="button"
            onClick={() => {
              const nuevos = [...detalles.nombreAlternativo, ""];
              handleDetallePatologiaChange(patologia, "nombreAlternativo", nuevos);
            }}
            disabled={bloqueado}
          >
            Agregar Enfermedad
          </button>
        </div>
      )}
    </div>
  );
})}


      
      <button style={{ padding: '10px 20px', marginRight: 10 }} onClick={handleSubmit}>Guardar</button>
<button style={{ padding: '10px 20px' }} onClick={bloqueado ? desbloquearCampos : bloquearCampos}>
  {bloqueado ? 'Desbloquear' : 'Bloquear'}
</button>
       
    </div>
  );
};

export default HistoriaClinica;